import React from 'react';
import './CopyBlocks.scss';

function CommonCopy({ copyContents, copyRef, id }) {
  return (
    <div
      className={copyRef ? 'commonCopy' : 'commonCopy--noanim'}
      ref={copyRef ? copyRef : null}
      id={id ? id : null}
    >
      <div className="commonCopy__contents">
        {copyContents.map((copy, i) => {
          return (
            <p className="commonCopy__contents__paragraphs" key={i}>
              {copy}
            </p>
          );
        })}
      </div>
    </div>
  );
}

export default CommonCopy;
